<template>
  <ankh-list>
    <template #btn-group>
      <el-button @click.native="$router.push('add')">{{$t('新增')}}</el-button>
      <el-button @click.native="handleExport">{{$t('导出')}}</el-button>
    </template>

    <template #search-form>
      <el-form-item :label="$t('硬件名称')">
        <el-input :placeholder="$t('硬件名称')" v-model="searchForm.name" clearable/>
      </el-form-item>
      <el-form-item :label="$t('协议代码')">
        <el-input :placeholder="$t('协议代码')" v-model="searchForm.protocolCode" clearable/>
      </el-form-item>
      <el-form-item :label="$t('创建时间')">
        <date-time-range-picker :start-time.sync="searchForm.startCreateTime" :end-time.sync="searchForm.endCreateTime" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{$t('搜索')}}</el-button>
        <el-button @click="$refs.list.reset()">{{$t('重置')}}</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">

      <table-list
          ref="list"
          :height="height"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          @selection-change="selection = $event">
        <el-table-column type="selection" width="50"/>
        <el-table-column type="index" :label="$t('序号')" width="80px" fixed />
        <el-table-column prop="name" :label="$t('创建时间')" fixed sortable>
          <template v-slot="{row}">
            {{row.createTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column prop="name" :label="$t('硬件名称')" fixed sortable />
        <el-table-column prop="model" :label="$t('产品型号')" />
        <el-table-column prop="brand" :label="$t('产品品牌')" />
        <el-table-column prop="photo" :label="$t('产品品牌图片')">
          <template v-slot="{row}">
            <preview-img :img-url="row.photo" />
          </template>
        </el-table-column>
        <el-table-column prop="suitTemperature" :label="$t('适用温度')" />
        <el-table-column prop="chipName" :label="$t('芯片名称')" />
        <el-table-column prop="sensorName" :label="$t('传感器名称')" />>
        <el-table-column prop="liquidCrystalName" :label="$t('液晶名称')" />
        <el-table-column prop="protocolCode" :label="$t('协议代码')" min-width="100">
          <template v-slot="{row}">
            <div class="flex" style="column-gap: 6px" v-if="row.protocolCode">
              <el-link :underline="false" type="primary">{{ row.protocolCode || "" }}</el-link>
              <i class="el-icon-copy-document" @click="handleCopy(row)" id="copyBtn" :data-clipboard-text="row.protocolCode" />
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="$t('操作')" min-width="60">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link :underline="false" type="primary" @click="$router.push('edit?code=' + row.code)">{{$t('编辑')}}</el-link>
<!--              <el-link :underline="false" type="danger" @click="handleDelete(row)">{{$t('删除')}}</el-link>-->
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>
  </ankh-list>
</template>

<script>
import {request, requestByTip} from "@/config/request";
import TableList from "@/components/table-list/TableList";
import AnkhList from "@/components/list/AnkhList.vue";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";
import DateTimeRangePicker from "@/components/time/DateTimeRangePicker.vue";
import {exportExcel} from "@/utils/export";
import {copyText} from "@/utils/copy";

export default {
  name: "HardwareManageList",
  components: {DateTimeRangePicker, PreviewImg, AnkhList, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
      addDialog: false,
    }
  },
  methods: {
    // 导出
    handleExport() {
      const codes = this.selection.map(item => item.code);
      exportExcel(codes, this.$api.intellectHardware.exportData);
    },

    handleCopy() {
      copyText("#copyBtn");
    },

    async handleDelete(row) {
      try {
        await requestByTip(this.$api.intellectHardware.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async handleSearch(params, setTotal) {
      try {
        if(params.startCreateTime) {
          params.startCreateTime = this.$moment(params.startCreateTime).valueOf();
          params.endCreateTime = this.$moment(params.endCreateTime).valueOf();
        }
        let res = await request(this.$api.intellectHardware.list, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        setTotal(res.pager?.itemCount);
      } catch (e) {
        console.error(e);
      }
    }
  },
}
</script>

<style scoped>

.content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
}

</style>
